import React, { FC } from "react";
import { GatsbyImage, GatsbyImageProps } from "gatsby-plugin-image";
import { getSanityImage, GetSanityImageParams } from "@/utils/getSanityImage";

export const SanityImage: FC<SanityImageProps> = ({
  imageAssetId,
  imageAssetConfig,
  ...gatsbyImageProps
}) => {
  const imageData = getSanityImage({ imageAssetId, imageAssetConfig });

  if (!imageData) {
    return null;
  }

  return <GatsbyImage image={imageData} {...gatsbyImageProps} />;
};

export interface SanityImageProps
  extends Omit<GatsbyImageProps, "image">,
    GetSanityImageParams {}
